import { App } from 'vue';
import { DSelect } from './DSelect/index';
import { DSelectTree } from './DSelectTree/index';
import { DColorpicker } from './DColorpicker/index';
import { DTime } from './DTime/index';
import { DAvatar } from './DAvatar/index';
import { DTimePicker } from './DTimePicker/index';
import { DPropertyEidtable } from './DProperty/index';
import { DBlueLine } from './DBlueLine/index';
import { DRename } from './DRename/index';
import { DTitleLine } from './DTitleLine/index';
import { DJsonParser } from './DJsonParser/index';
import { DPropertyTable } from './DPropertyTable/index';
import { DEditableTable } from './DEditableTable/index';
//add
export function registerShansheComp(app: App) {
  app
    .use(DSelect)
    .use(DSelectTree)
    .use(DColorpicker)
    .use(DTime)
    .use(DAvatar)
    .use(DTimePicker)
    .use(DPropertyEidtable) // 这里可以多次使用，因为每次都会返回一个新的实例;
    .use(DBlueLine)
    .use(DRename)
    .use(DTitleLine)
    .use(DJsonParser)
    .use(DPropertyTable)
    .use(DEditableTable);
}
